"use client";

import * as amplitude from "@amplitude/analytics-browser";

const API_KEY = "0b82af29a38cb1819331b6c8e2d6c753";

type AmplitudeInitOptions = Parameters<typeof amplitude.init>[2];

export function initializeAnalytics(): void {
  if (import.meta.env.DEV) {
    return;
  }

  const options: AmplitudeInitOptions = {
    appVersion: undefined,
    fetchRemoteConfig: false,
    autocapture: {
      pageViews: false,
      attribution: {
        trackingMethod: ["userProperty", "eventProperty"],
      },
    },
  };

  amplitude.init(API_KEY, undefined, options);
}

export function trackPageView() {
  const url = new URL(window.location.href);
  const pageViewParams = {
    path: url.pathname,
    query: url.search || undefined,
    hash: url.hash || undefined,
    title: document.title,
  };

  if (import.meta.env.DEV) {
    console.log("[Amplitude] Page Viewed", pageViewParams);
    return;
  }
  amplitude.track("Page Viewed", pageViewParams);
}

export const trackEvent = (eventName: string, properties?: Record<string, unknown>) => {
  if (!import.meta.env.DEV) {
    amplitude.track(eventName, properties);
  } else {
    console.log("📊 [Analytics]", eventName, properties);
  }
};
